// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Home__version____IsfR {\n  font-size: 80%;\n  opacity: 0.7;\n  margin: 0 auto;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Home/Home.styl"],"names":[],"mappings":"AAAA;EACE,cAAU;EACV,YAAQ;EACR,cAAO;AACT","sourcesContent":[".version\n  font-size 80%\n  opacity .7\n  margin 0 auto\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"version": "Home__version____IsfR"
};
export default ___CSS_LOADER_EXPORT___;
